var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcSearchContext(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 59 59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#003C71",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.707 54.465L46.082 41.84a27.184 27.184 0 0 1-4.242 4.242l12.625 12.625a1 1 0 0 0 1.414 0l2.828-2.828a1 1 0 0 0 0-1.414z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 50C11.193 50 0 38.807 0 25S11.193 0 25 0s25 11.193 25 25c-.015 13.8-11.2 24.985-25 25zm0-48C12.297 2 2 12.297 2 25s10.297 23 23 23 23-10.297 23-23C47.986 12.303 37.697 2.014 25 2z"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#003C71",
    strokeLinecap: "square",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 21v-5h4v5M18 25v-4h12l2 4M18 31l-2-6h20l-3 6M15 32c0 2.2 1.8 4 4 4 1.5 0 2.8-.9 3.5-2.1.7 1.2 2 2.1 3.5 2.1s2.8-.9 3.5-2.1c.7 1.2 2 2.1 3.5 2.1 2.2 0 4-1.8 4-4"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSearchContext);
export default __webpack_public_path__ + "static/media/ic-search-context.9c8883715ea4c8f5734e7a9390855266.svg";
export { ForwardRef as ReactComponent };